import { createApp, h, type Plugin } from 'vue';
import { ElMessage } from 'element-plus';
import nxtVue from '@nextories/vue-core-components';
import '@nextories/vue-core-components/src/assets/scss/external/element-variables.scss';
import './assets/scss/app.scss';
import App from './App.vue';
import { i18n, i18nPlugin } from './plugins/i18n';
import piniaPlugin from './plugins/pinia';
import router from './router';
import { useAuthStore } from './store/authStore';
import { http } from './utils/api';
import { setSessionLostHandler } from './utils/http';

const app = createApp({
  data() {
    return {
      // Read by the SetCssClass mixin of the core components: nxt-preloader, nxt-tooltip...
      prefixCSS: import.meta.env.nxt.prefixCSS ? `${import.meta.env.nxt.prefixCSS}-` : '',
    };
  },
  render() {
    return h(App);
  },
});

app.use(i18nPlugin);
app.use(piniaPlugin);
app.config.globalProperties.$API = http;
// Element Plus in French, FontAwesome, vee-validate rules and the core components.
// The core types its plugin as { install: null }.
app.use(nxtVue as unknown as Plugin);
app.use(router);

setSessionLostHandler(() => {
  const auth = useAuthStore();
  // While the stored session is being checked, the router guard handles the redirection
  if (!auth.ready || !auth.isLogged) {
    return;
  }
  auth.clear();
  ElMessage.warning(i18n.global.t('app.errors.sessionLost'));
  const current = router.currentRoute.value;
  router.push({ name: 'login', query: current.meta.public ? {} : { u: current.fullPath } });
});

app.mount('#nxt-one');
